// src/components/BlogImage.tsx
import React, { useState, useMemo, useEffect } from 'react';
import { generateBlogTitleSvgDataUrl } from '../utils/generateBlogImage';

interface BlogImageProps {
  src?: string;
  title: string;
  category?: string;
  alt?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

const BlogImage: React.FC<BlogImageProps> = ({
  src,
  title,
  category,
  alt,
  className = 'w-full h-full object-cover',
  loading = 'lazy'
}) => {
  const [hasError, setHasError] = useState(false);

  // Generate fallback SVG data URL containing the post title & styling
  const fallbackUrl = useMemo(
    () => generateBlogTitleSvgDataUrl(title, category),
    [title, category]
  );

  // Reset error state if src changes
  useEffect(() => {
    setHasError(false);
  }, [src]);

  const isMissing = !src || src.trim() === '';
  const displaySrc = (isMissing || hasError) ? fallbackUrl : src;

  return (
    <img
      src={displaySrc}
      alt={alt || title}
      loading={loading}
      className={className}
      onError={() => {
        if (!hasError) {
          setHasError(true);
        }
      }}
    />
  );
};

export default BlogImage;
